import { createSlice } from '@reduxjs/toolkit';

const assistantSlice = createSlice({
  name: 'assistant',
  initialState: { isOpen: false, pendingMessage: null as string | null },
  reducers: {
    openAssistant: (state) => {
      state.isOpen = true;
    },
    openAssistantWithMessage: (state, action: { payload: string }) => {
      state.isOpen = true;
      state.pendingMessage = action.payload;
    },
    clearAssistantPendingMessage: (state) => {
      state.pendingMessage = null;
    },
    closeAssistant: (state) => {
      state.isOpen = false;
    },
    toggleAssistant: (state) => {
      state.isOpen = !state.isOpen;
    },
  },
});

export const { openAssistant, openAssistantWithMessage, clearAssistantPendingMessage, closeAssistant, toggleAssistant } = assistantSlice.actions;
export default assistantSlice.reducer;
